/**
 * Components
 */

// Custom
import Hero from './custom/hero';

// ------
// Public
// ------
const index = () => {
	Hero.init();
};

// Export
export default index;